import { IActiveMarker } from '../../types/marker/IActiveMarker';
import IMarker from '../../types/marker/IMarker';

const setActiveMarker = <T extends IMarker>(activeMarker: IActiveMarker<T>, marker: T) => {
  activeMarker.value = marker;
};
export default setActiveMarker;
